import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItemText from '@material-ui/core/ListItemText';
import Fab from '@material-ui/core/Fab';
import sortBy from "lodash/sortBy"
import { useEffect, useState } from 'react';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import {useSideBarStatus} from '../store/sidebarContext';

interface propTypes {
    dataList: Array<any>,
    onClick: (e: number) => void,
    currentCategorie: number,
    isOnEdit: Boolean
}

const DetailPageSideBar = (props: propTypes) => {
    const [openSideBar, setOpen] = useState(true)
    const [onHoverPane, setOnHoverPane] = useState(false)
    const {setSidebarStatus} = useSideBarStatus()

    useEffect(()=>{
        setSidebarStatus(openSideBar)
    },[openSideBar])

    const list = (categories: Array<{ id: number, name: string }>) => {
        return sortBy(categories, ['name']).map((item, index) => {
            return <ListItem
                className='listItem'
                classes={{ root: 'listItemDS', selected: 'selectedDS' }}
                key={index}
                button selected={props.currentCategorie === item.id}
                onClick={() => props.onClick(item.id)}>
                <ListItemText className="listItemTex" primary={item.name} />
            </ListItem>
        })
    }

    const displayList = () => {
        return props.dataList.map((item, index) => {

            return (
                <div key={index} className='listContainer' data-test="listContainer">
                    <List
                        component="nav"
                        aria-label="secondary mailbox folder"
                        subheader={
                            <ListSubheader
                                disableSticky={true}
                                className="listSubHeader">
                                {item.name.toUpperCase()}
                            </ListSubheader>
                        }>
                        {list(item.categories)}
                    </List>
                </div>
            )

        })
    }
    const onHover = () => {
        if (openSideBar) {
            setOnHoverPane(true)
        }
    }

    const onLeave = () => {
        if (openSideBar) {
            setOnHoverPane(false)
        }
    }

    // const handleSideBar = () =>{
    //     setOpen(!openSideBar)
    //     setSidebarStatus(openSideBar)
    // }

    return (
        <div
            className={`categorieMenu ${openSideBar ? '' : 'close'}`}
            onMouseEnter={onHover}
            onMouseLeave={onLeave} >
            <div>
                <div className={`toggle ${onHoverPane ? '' : 'noDisplay'}`}>
                    <Fab size="small" color="secondary" aria-label="add" classes={{ root: 'fabDS' }}>
                        {openSideBar ?
                            <NavigateBeforeIcon className="toggle-pane-icon" onClick={() => setOpen(!openSideBar)} />
                            : <NavigateNextIcon className="toggle-pane-icon" onClick={() => setOpen(!openSideBar)} />}
                    </Fab>
                </div>
                {openSideBar ? displayList() : null}
            </div>
            <iframe id="csi-iframe" style={{ height: 0, width: '100%', visibility: 'hidden' }}></iframe>
        </div>
    )

}

export default DetailPageSideBar
